import { ExternalLink } from "./components/ExternalLink";
import { InternalLink } from "./components/InternalLink";

export const Link = {
  Internal: InternalLink,
  External: ExternalLink,
};
